// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Edit = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.793 2.207a1 1 0 0 1 1.414 0l1.586 1.585c.39.39.39 1.025 0 1.415L5.999 15H3v-3zM4 12.414V14h1.585l7.853-7.854-1.585-1.585zm8.56-8.56 1.585 1.585.94-.939L13.5 2.914z"
    />
  </svg>
);
const ForwardRef = forwardRef(Edit);
export default ForwardRef;
